import React from 'react'
import * as S from './styles'
import PropTypes from 'prop-types'

const AvatarPhoto = ({ src, contain = false, customSize }) => <S.Container src={src} contain={contain} customSize={customSize} />

export default AvatarPhoto

AvatarPhoto.propTypes = {
  src: PropTypes.string,
  contain: PropTypes.bool,
  customSize: PropTypes.number
}
